import { useHits } from 'react-instantsearch';
import CardSquare from '../card-square/card-square';
import LinkWrapper from '../link-wrapper/link-wrapper';
import { formatDateLong } from '../helpers/date-utils';
import type { JournalHit } from '../search/search-hit-types';

export function SearchHitsJournal() {
    const { hits } = useHits<JournalHit>();
    return (
        <div className="mx-6 md:mx-0 md:grid md:grid-cols-14">
            <div className="md:col-span-12 md:col-start-2">
                <ul className="md:grid md:grid-cols-2 md:gap-6">
                    {hits.map((hit) => {
                        if (hit.pageType !== 'pageJournal') return null;
                        return (
                            <li
                                key={hit.objectID}
                                data-insights-object-id={hit.objectID}
                                data-insights-position={hit.__position}
                                data-insights-query-id={hit.__queryID}
                            >
                                <LinkWrapper href={hit.url} className={`group gtm-search-hit__link`}>
                                    <CardSquare
                                        overline={hit.contentTypeDisplay}
                                        title={hit.title}
                                        summary={hit.summary}
                                        imageUrl={hit.heroImage}
                                        author={hit.author}
                                        date={formatDateLong(hit.publishDate) || undefined}
                                    />
                                </LinkWrapper>
                            </li>
                        );
                    })}
                </ul>
            </div>
        </div>
    );
}

export default SearchHitsJournal;
